<template>
	<div>
		<el-card class="searchItemFlex">
			<el-input
				v-model="queryParam.modifierName"
				placeholder="交审人"
				size="mini"
				clearable></el-input>
			<el-select
				v-model="queryParam.bmId"
				placeholder="交审人部门"
				size="mini"
				filterable
				clearable
				@clear="queryParam.bmId = 0">
				<el-option
					v-for="item in bmList"
					:key="item.bmid"
					:label="item.bmname"
					:value="item.bmid"></el-option>
			</el-select>
			<el-date-picker
				size="mini"
				v-model="queryParam.dateRange"
				clearable
				type="daterange"
				align="right"
				unlink-panels
				range-separator="至"
				start-placeholder="开始日期"
				end-placeholder="结束日期"
				value-format="yyyy-MM-dd"
				format="yyyy-MM-dd"
				:picker-options="pickerOptions">
			</el-date-picker>
			<el-radio-group v-model="queryParam.type" size="mini">
				<el-radio-button :label="0">交底</el-radio-button>
				<el-radio-button :label="1">审核</el-radio-button>
				<el-radio-button :label="2">全部</el-radio-button>
			</el-radio-group>
			<el-button type="primary" size="mini" @click="getDisaudList"
				><i class="el-icon-search"></i>&nbsp;查询</el-button
			>
			<el-button type="warning" size="mini" @click="reset"
				><i class="el-icon-refresh"></i>&nbsp;重置</el-button
			>
			<el-button type="success" size="mini" @click="exportList" class="right"
				><i class="el-icon-download"></i>&nbsp;导出数据</el-button
			>
		</el-card>
		<el-card>
			<el-table
				id="disaudTable"
				:data="disaudLogList"
				ref="DisAudTable"
				height="610"
				size="mini"
				border
				style="width: 100%"
				v-loading="disaudLoading"
				@sort-change="SortChange"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(255, 255, 255, 0.8)">
				<el-table-column label="序号" type="index" width="70"></el-table-column>
				<el-table-column
					label="交审人"
					prop="modifierName"
					width="100"
					show-overflow-tooltip
					:sortable="'custom'"></el-table-column>
				<el-table-column
					label="交审时间"
					prop="disaudDate"
					width="140"
					:sortable="'custom'">
					<template slot-scope="scope">
						<el-tag type="info" size="mini">{{
							scope.row.disaudDate | dateformatAll("YYYY-MM-DD")
						}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column
					label="性质"
					prop="type"
					width="100"
					:sortable="'custom'">
					<template slot-scope="scope">
						<el-tag type="primary" size="mini" v-if="scope.row.type == 0"
							>交底</el-tag
						>
						<el-tag type="warning" size="mini" v-else>审核</el-tag>
					</template>
				</el-table-column>
				<el-table-column
					label="项目编号"
					prop="panum"
					width="160"
					show-overflow-tooltip
					:sortable="'custom'"></el-table-column>
				<el-table-column
					label="项目名称"
					prop="paname"
					width="240"
					show-overflow-tooltip
					:sortable="'custom'"></el-table-column>
				<el-table-column
					label="纸电金额"
					prop="zdMoney"
					width="120"
					show-overflow-tooltip></el-table-column>
				<el-table-column
					label="进馆卷数"
					prop="enterNum"
					width="100"
					show-overflow-tooltip></el-table-column>
				<el-table-column
					label="备注"
					prop="notes"
					show-overflow-tooltip></el-table-column>
			</el-table>
			<!--分页部分-->
			<el-pagination
				background
				@size-change="pagesizeChange"
				@current-change="pagenumChange"
				:current-page="queryParam.pageNum"
				:page-sizes="[10, 50, 100, 200, 500]"
				:page-size="queryParam.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				style="margin-top: 10px">
			</el-pagination>
		</el-card>
	</div>
</template>
<script>
import FileSaver from "file-saver"
import XLSX from "xlsx"
import dayjs from "dayjs"
import Moment from "moment"
export default {
	data() {
		return {
			queryParam: {
				modifierName: "",
				bmId: null,
				dateRange: [],
				type: 2,
				pageNum: 1,
				pageSize: 100,
				order: 0,
			},
			total: 0,
			bmList: [],
			pickerOptions: {
				shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
							picker.$emit("pick", [start, end])
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
							picker.$emit("pick", [start, end])
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
							const end = new Date()
							const start = new Date()
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
							picker.$emit("pick", [start, end])
						},
					},
					{
						text: "本月",
						onClick(picker) {
							var now = new Date()
							const begin = Moment(now).startOf("month").format("YYYY-MM-DD")
							const end = Moment(now).endOf("month").format("YYYY-MM-DD")
							picker.$emit("pick", [begin, end])
						},
					},
					{
						text: "本年",
						onClick(picker) {
							var now = new Date()
							const begin = Moment(now).startOf("year").format("YYYY-MM-DD")
							const end = Moment(now).endOf("year").format("YYYY-MM-DD")
							picker.$emit("pick", [begin, end])
						},
					},
				],
			},
			disaudLogList: [],
			disaudLoading: false,
		}
	},
	mounted() {
		this.getxmBmList()
		this.getDisaudList()
	},
	methods: {
		//获取列表
		async getDisaudList() {
			this.disaudLoading = true
			const { data: res } = await this.$http.post(
				"trace/disaudLog",
				this.queryParam
			).catch(err => err)
			if (res) {
				this.disaudLogList = res.disaudList
				this.total = res.total
			}
			this.disaudLoading = false
		},
		//获取待选的部门列表
		async getxmBmList() {
			const { data: res } = await this.$http.post("item/xmBm").catch(err => err)
			if (res) {
				this.bmList = res
			}
		},
		SortChange(column) {
			if (column.prop == "disaudDate") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 1
				} else {
					this.queryParam.order = 0
				}
			} else if (column.prop == "modifierName") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 3
				} else {
					this.queryParam.order = 2
				}
			} else if (column.prop == "type") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 5
				} else {
					this.queryParam.order = 4
				}
			} else if (column.prop == "panum") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 7
				} else {
					this.queryParam.order = 6
				}
			} else if (column.prop == "paname") {
				if (column.order == "ascending" || column.order == null) {
					this.queryParam.order = 9
				} else {
					this.queryParam.order = 8
				}
			} else {
				this.queryParam.order = 0
			}
			this.getDisaudList()
		},
		reset() {
			this.queryParam = {
				modifierName: "",
				bmId: null,
				dateRange: [],
				type: 2,
				pageNum: 1,
				pageSize: 100,
				order: 0,
			}
			this.$refs.DisAudTable.columns.forEach(element => {
				element.order = ""
			})
			this.getDisaudList()
		},
		pagesizeChange(newSize) {
			this.queryParam.pageSize = newSize
			this.queryParam.pageNum = 1
			this.getDisaudList()
		},
		pagenumChange(newNum) {
			this.queryParam.pageNum = newNum
			this.getDisaudList()
		},
		//列表导出
		async exportList() {
			const confirmresult = await this.$confirm(
				"将要导出当前页面的数据，一次最多500条，如需更多请跳页分批导出。请确定是否继续？",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).catch(err => err)
			if (confirmresult !== "confirm") {
				return this.$message.info("已取消操作！")
			}
			this.$message.warning("正在导出,请稍候...")
			var xlsxParam = { raw: true } //转换成excel时，使用原始的格式
			var wb = XLSX.utils.table_to_book(
				document.querySelector("#disaudTable"),
				xlsxParam
			) //outTable为列表id
			var wbout = XLSX.write(wb, {
				bookType: "xlsx",
				bookSST: true,
				type: "array",
			})
			try {
				var dateNow = new Date()
				FileSaver.saveAs(
					new Blob([wbout], { type: "application/octet-stream;charset=utf-8" }),
					"交底派审记录导出_" +
						dayjs(dateNow).format("YYYYMMDD_HHmmss") +
						".xlsx"
				)
				this.$message.success("导出成功！")
			} catch (e) {
				this.$message.error("导出失败！")
				if (typeof console !== "undefined") console.log(e, wbout)
			}
		},
	},
	computed: {},
}
</script>
<style scoped></style>
